var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-card',[_c('v-card-title',[_vm._v(" مدیریت سفارشات مستقیم "),_c('v-spacer'),_c('v-btn',{attrs:{"color":"primary"},on:{"click":function($event){return _vm.createNewItem()}}},[_vm._v("ثبت سفارش مستقیم +")])],1),_c('v-divider'),_c('v-card-text',[_c('trade-request-direct-list',{ref:"TradeRequestDirectList"})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }